const NOTES_REDUX_CONSTANT = {
  GET_OPPORTUNITY_NOTE: 'GET_OPPORTUNITY_NOTE',
  ADD_OPPORTUNITY_NOTE: 'ADD_OPPORTUNITY_NOTE',
  UPDATE_OPPORTUNITY_NOTE: 'UPDATE_OPPORTUNITY_NOTE',
  DELETE_OPPORTUNITY_NOTE: 'DELETE_OPPORTUNITY_NOTE',
};
export default NOTES_REDUX_CONSTANT;
